import { useEffect } from "react"
import { useStoreContext } from "../../contexts/store.context"
import { CategoryFilter } from "./CategoryFilter"
import { Group } from "./Group"
import { AttributeFilter, AttributeFilterGroup } from "./AttributeFilter"

export const Panel = () => {
    const { showFilters, availableFiltering } = useStoreContext()
    const attributeFilters = Object.entries(availableFiltering?.attributes ?? [])

    useEffect(() => {
        console.log('availableFiltering changed', availableFiltering)
    }, [availableFiltering])

    if (!showFilters) return null

    return <div className="hidden md:flex flex-col gap-8 p-4 text-sm tracking-wide max-w-80 w-full">
        <CategoryFilter />
        <hr className="border-white/15" />
        <AttributeFilterGroup />

    </div>
}